<template>
  <div class="container" v-if="isShow">
    <div class="back-contain" v-if="showBack">
      <div class="tap-box">
        <div class="content">
          <p class="con">抱歉您当前的账号暂无权限</p>
          <p class="con">请联系系统管理员</p>
        </div>
        <div class="iknow" @click="hideBack()">知道了</div>
      </div>
    </div>
    <div class="pg-pd12">
      <div class="prov-total">
        <div class="prov-total-sel">
          <div  v-if="isProvPriv==0" class="select">
            <span>{{cityName}}</span>
          </div>
          <div v-else class="select" @click="showCity()">
            <span>{{cityName}}</span>
            <div class="select-icon"></div>
          </div>
          <div class="select" @click="showQuarter()">
            <span>{{quarterName}}</span>
            <div class="select-icon"></div>
          </div>
        </div>

        <div class="content">
          <div class="content-item">
            <!--省与州市都显示-->
            <div class="total"><scoreCard :type="1" :data="assessment"></scoreCard></div>
            <!-- 是州市时显示 -->
            <div v-if="isProvPriv==0" class="total" @click="navToRank()"><scoreCard :type="2" :data="assessment"></scoreCard></div>
          </div>
          <!-- <div style="height:250px; margin-bottom:24px;">
            <doubleLineCharts :doubleData="doubleData"></doubleLineCharts>
            </div> -->
        </div>
      </div>

       <div class="prov-total">
        <!-- <tab class="mt0" :tabList="dataTab" :name="'dataTab'"  @onSwitch="tabSwitch"></tab>--><!-- 没有时间。tab隐藏-->
        <div class="prov-title">考评得分</div>
        <div class="content" v-if="assessScoreInfo"> <!--有tab时加上 mt20-->
            <div class="content-pd16" v-show="curIndex==0">
              <div class="com-box">
                <div class="com-box-left">
                  <div>对比上季度</div>
                  <van-switch v-model="isOpen" active-color="#07c160" inactive-color="#E4E4E5" @on-change="showCopare"/>
                </div>
                <!-- <div class="com-box-right" @click="navTo()">查看评分细则<img class="icon" src="../../assets/image/t-right.png"/></div> --><!--隐藏评分细则-->
              </div>
              <evolve :listData="sortDetailList" :isOpen="isOpen" @navToScoreList="navToScoreList"></evolve>
            </div>
            <div class="time-cont" v-show="curIndex==1">
                <div class="score-num">共3条扣分记录</div>
                <div class="score-list">
                  <div class="score-item">
                    <div class="tit">
                      <div class="name">投诉5分钟内未响应</div>
                      <div class="down">-0.5分</div>
                    </div>
                    <div class="txt">投诉地区：大理州-地热国</div>
                    <div class="txt">响应时长：7分钟</div>
                    <div class="txt">投诉时间：2019-11-01 12:31:22</div>
                  </div>
                  <div class="score-item">
                    <div class="tit">
                      <div class="name">投诉5分钟内未响应</div>
                      <div class="down">-0.5分</div>
                    </div>
                    <div class="txt">投诉地区：大理州-地热国</div>
                    <div class="txt">响应时长：7分钟</div>
                    <div class="txt">投诉时间：2019-11-01 12:31:22</div>
                  </div>
                </div>
              </div>
        </div>
        <!-- 没有数据提示 -->
            <div v-else class="noData-bg">
              <nodata :noData="noData"></nodata>
            </div>
       </div>

    </div>

      <common-picker v-show="compickFlag" ref="commonPickerQuarter" :typeList="newQuarterList" :cols="cols1" @getTypeValue="getQuarterValue"></common-picker>
      <common-picker v-show="isProvPriv==1&&compickFlag2" ref="commonPickerCity" :typeList="newCityList" :cols="cols1" @getTypeValue="getCityValue"></common-picker>

  </div>
</template>
<script>
    import nodata from './components/nodata';// 没有数据
    import evolve from './components/evolve';
    import scoreCard from './components/score-card';
    import tab from 'comps/tab';
    // import doubleLineCharts from '../../components/DoubleLineCharts';//双折线
    import commonPicker from '../../components/base/commonPicker'// 选择季度
    // import errorPage from './components/refresh';
    import api from '../../service/modules/appraise';

    export default {
        name: 'provincialDetail',
        components: {
            scoreCard,
            tab,
            evolve,
            // doubleLineCharts,
            commonPicker,
            nodata
            // errorPage
        },

        data () {
            return {
                assessScoreInfo: {},
                noData: {
                    title: '暂无数据'
                },
                compickFlag: false,
                compickFlag2: false,
                area: '',
                isOpen: false,
                isProvPriv: 0,
                cols1: 1,
                city: true,
                dataTab: ['类型', '时间'],
                // 双折线图
                doubleData: [
                    { 'xAxis': '1月', 'left': '35', 'right': '1' },
                    { 'xAxis': '2月', 'left': '15', 'right': '1' },
                    { 'xAxis': '3月', 'left': '8', 'right': '2' },
                    { 'xAxis': '4月', 'left': '12', 'right': '4' },
                    { 'xAxis': '5月', 'left': '11', 'right': '2' },
                    { 'xAxis': '6月', 'left': '6', 'right': '1' },
                    { 'xAxis': '7月', 'left': '3', 'right': '3' },
                    { 'xAxis': '8月', 'left': '10', 'right': '6' },
                    { 'xAxis': '9月', 'left': '15', 'right': '6' },
                    { 'xAxis': '10月', 'left': '2', 'right': '6' },
                    { 'xAxis': '11月', 'left': '24', 'right': '2' },
                    { 'xAxis': '12月', 'left': '20', 'right': '1' }
                ],
                yearAndQuarterList: [],
                areaList: [],
                newQuarterList: [],
                quarterList: [],
                cityList: [],
                newCityList: [],
                quarterName: '',
                cityName: '',
                test2: {
                    title: '考核排名',
                    num: '2',
                    diff: '+1'
                },
                curIndex: 0,
                cityCode: '',
                assessment: {
                    title: '考核分',
                    num: 0,
                    diff: ''
                },
                detailList: [],
                areaInfo: {},
                // areaType: 1,
                detailInfo: {},
                complainQuarter: '',
                respond: {},
                isShow: false,
                showBack: false
            }
        },

        computed: {
            sortDetailList () {
                return this.detailList.sort((x, y) => {
                    var valueN = x.assessType;
                    var valueM = y.assessType;
                    if (valueN < valueM) return -1;
                    else if (valueN > valueM) return 1;
                    else return 0;
                });
            }
        },

        watch: {
            'newCityList': {
                handler (val) {
                    this.compickFlag2 = false;
                    this.$nextTick(() => {
                        this.compickFlag2 = true;
                    });
                }

            },
            'newQuarterList': {
                handler (val) {
                    this.compickFlag = false;
                    this.$nextTick(() => {
                        this.compickFlag = true;
                    });
                }
            }
        },

        methods: {
            hideBack () {
                this.showBack = false
            },
            // 考核类型跳转, id, directDetail, assessType
            navToScoreList (row) {
                let areaCont = {// 传给游客投诉的城市信息
                    area: this.cityCode,
                    areaName: this.cityName,
                    quarter: this.quarter,
                    year: this.year,
                    score: row.score,
                    totalScore: row.totalScore
                }
                sessionStorage.setItem('areaCont', JSON.stringify(areaCont))
                sessionStorage.setItem('detailInfo', JSON.stringify(this.detailInfo))
                this.respond = {
                    year: this.year,
                    quarter: this.complainQuarter,
                    cityId: this.cityCode
                }
                sessionStorage.setItem('respondInfo', JSON.stringify(this.respond))// 传给考核详情页的值
                console.log(row);

                if (row.directDetail == '0') { // 是否直接跳转详情页，0是否
                    this.$router.push({
                        path: '/appraise/deductionList', // 跳转考核列表
                        query: {
                            id: row.id,
                            quarterName:this.quarterName,
                            pageType:row.assessType//从哪个入口进去的详情页
                        }
                    });
                } else {
                    this.$router.push({
                        path: '/appraise/complaintsRate', // 跳转至游客投诉详情
                        query: {
                            id: row.id,
                            assessType: row.assessType, // assessType作为考核详情接口subType参数。后台判断要查哪类详情信息
                            quarterName:this.quarterName
                        }
                    });
                }
            },
            // 对比上季度
            showCopare () {
                this.isOpen = !this.isOpen
            },
            getAssessScore () {
                // 省级列表
                api.getAssessScoreByDefault({ isProvPriv: this.isProvPriv, area: this.cityCode, year: this.year, quarter: this.quarter }).then(res => {
                    if (res.data.assessScoreInfo) {
                        this.assessment = {// 默认取第一条数据
                            title: '考核分',
                            num: res.data.assessScoreInfo.score,
                            diff: res.data.assessScoreInfo.scoreChange,
                            title2: '考核排名',
                            ranking: res.data.assessScoreInfo.ranking,
                            rankingChange: res.data.assessScoreInfo.rankingChange
                        }
                        this.detailList = res.data.assessScoreInfo.detail
                    } else {
                        this.assessment = {// 默认取第一条数据
                            title: '考核分',
                            num: '0',
                            diff: '-',
                            title2: '考核排名',
                            ranking: '0',
                            rankingChange: '-'
                        }
                        this.detailList = []
                    }
                    this.getCityInfo(this.year, this.quarter, this.cityCode)// 如果是省级权限，默认显示的数据
                })
            },
            // 省级获取州市信息
            getCityInfo (year, quarter, area) {
                api.getAssessScoreByDefault({ area: area, year: year, quarter: quarter }).then(res => {
                    this.assessScoreInfo = res.data.assessScoreInfo
                    if (res.data.assessScoreInfo) {
                        this.assessment = {
                            title: '考核分',
                            num: res.data.assessScoreInfo.score,
                            diff: res.data.assessScoreInfo.scoreChange,
                            title2: '考核排名',
                            ranking: res.data.assessScoreInfo.ranking,
                            rankingChange: res.data.assessScoreInfo.rankingChange
                        }
                        this.detailList = res.data.assessScoreInfo.detail
                        // this.areaInfo = {// 切换州市季度传给排名页的值
                        //     areaType: res.data.assessScoreInfo.areaType,
                        //     year: res.data.assessScoreInfo.year,
                        //     quarter: res.data.assessScoreInfo.quarter
                        // }
                        this.detailInfo = {// 传给详情页的州市类型和名称
                            areaType: res.data.assessScoreInfo.areaType,
                            areaName: res.data.assessScoreInfo.areaName
                        }
                    } else {
                        this.assessment = {
                            title: '考核分',
                            num: '0',
                            diff: '-',
                            title2: '考核排名',
                            ranking: '-',
                            rankingChange: '-'
                        }
                        this.detailList = []
                    }
                })
            },
            // 州市获取接口（州市权限使用）
            getInfo (year, quarter, area) {
                this.assessment = {// 清数据
                    title: '考核分',
                    num: '0',
                    diff: '-',
                    title2: '考核排名',
                    ranking: '-',
                    rankingChange: '-'
                }
                this.detailList = []
                api.getAssessScoreByDefault({ area: area, year: year, quarter: quarter }).then(res => {
                    if (res.ret === 0) {
                        this.assessScoreInfo = res.data.assessScoreInfo
                        this.cityName = res.data.assessScoreInfo.areaName
                        if (res.data.assessScoreInfo) {
                            this.assessment = {
                                title: '考核分',
                                num: res.data.assessScoreInfo.score,
                                diff: res.data.assessScoreInfo.scoreChange,
                                title2: '考核排名',
                                ranking: res.data.assessScoreInfo.ranking,
                                rankingChange: res.data.assessScoreInfo.rankingChange
                            }
                            this.detailList = res.data.assessScoreInfo.detail
                            // this.areaInfo = {
                            this.areaType = res.data.assessScoreInfo.areaType// 切换州市季度传给排名页的值
                            this.year = res.data.assessScoreInfo.year
                            this.quarter = res.data.assessScoreInfo.quarter
                            // }
                            this.detailInfo = {// 传给详情页的州市类型和名称
                                areaType: res.data.assessScoreInfo.areaType,
                                areaName: res.data.assessScoreInfo.areaName
                            }
                        } else {
                            this.assessment = {// 清数据
                                title: '考核分',
                                num: '0',
                                diff: '-',
                                title2: '考核排名',
                                ranking: '-',
                                rankingChange: '-'
                            }
                            this.detailList = []
                        }
                    } else {
                        this.showBack = true
                    }
                })
            },

            getCity () { // 季度、省市
                this.isShow = false
                api.getMainAssessInfo().then(res => {
                    if (res.ret === 0) {
                        this.yearAndQuarterList = res.data.yearAndQuarterList // 季度列表
                        this.areaList = res.data.areaList// 去城市
                        this.isProvPriv = res.data.isProvPriv
                        if (this.isProvPriv == 0) {
                            this.cityCode = res.data.area
                        }
                        this.isShow = true
                        // 提取季度有效数据
                        let arr = [];
                        for (let i = 0, length = this.yearAndQuarterList.length; i < length; i++) {
                            arr[i] = {};
                            arr[i].code = this.yearAndQuarterList[i].code;
                            arr[i].text = this.yearAndQuarterList[i].name;
                            arr[i].complainQuarter = this.yearAndQuarterList[i].complainQuarter;
                            // 取第一条季度为默认
                            if (i === 0 && this.isProvPriv == 0) {
                                this.quarterName = arr[0].text
                                this.year = arr[0].code.substr(0, 4)// 取年
                                this.quarter = arr[0].code.substring(5)// 取季度
                                this.complainQuarter = arr[0].complainQuarter// 取季度英文
                            }
                        }
                        // 重新赋值下传组件数组
                        this.newQuarterList.push(arr)
                        // 提取州市有效数据
                        let arr2 = [];
                        for (let k = 0, length = this.areaList.length; k < length; k++) {
                            arr2[k] = {};
                            arr2[k].code = this.areaList[k].code;
                            arr2[k].text = this.areaList[k].name;
                        }
                        // 重新赋值下传组件数组
                        this.newCityList.push(arr2)
                    } else {
                        this.$Message.error('res.data.msg')
                    }
                    if (this.isProvPriv == 0) {
                        this.getInfo(this.year, this.quarter, this.cityCode)
                    }
                })
            },
            showQuarter () {
                this.compickFlag = true
                this.$refs.commonPickerQuarter.showPicker();
            },
            showCity () {
                this.compickFlag2 = true
                this.$refs.commonPickerCity.showPicker();
            },
            // 选择季度
            getQuarterValue (value) {
                this.quarterName = value[0].text
                this.year = value[0].code.substr(0, 4)// 取年
                this.quarter = value[0].code.substring(5)// 取季度
                this.complainQuarter = value[0].complainQuarter
                if (this.isProvPriv == 1) {
                    this.getCityInfo(this.year, this.quarter, this.cityCode)
                } else {
                    this.getInfo(this.year, this.quarter, this.cityCode)
                }
            },
            // 选择州市
            getCityValue (value) {
                this.cityName = value[0].text
                this.cityCode = value[0].code
                this.getCityInfo(this.year, this.quarter, this.cityCode)
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoringList', query: { }
                });
            },
            // 州市排名
            navToRank () {
                this.areaInfo = {// 切换州市季度传给排名页的值
                    areaType: this.areaType,
                    year: this.year,
                    quarter: this.quarter
                }
                sessionStorage.setItem('content', JSON.stringify(this.areaInfo))
                this.$router.push({
                    path: '/appraise/ranking', query: { }
                });
            },
            tabSwitch (index) {
                this.curIndex = index
            }
        },

        mounted () {
          
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // 通过 `vm` 访问组件实例
                if (from.path === '/appraise/provincial') {
                    // 一定是从A进到B页面才刷新

                    vm.isProvPriv = to.query.isProvPriv
                    vm.year = to.query.year
                    vm.quarter = to.query.quarter
                    vm.cityCode = to.query.area
                    vm.cityName = to.query.areaName
                    vm.quarterName = to.query.quarterName
                    vm.compickFlag = to.query.compickFlag
                    vm.compickFlag2 = to.query.compickFlag2
                    vm.getAssessScore();
                } else {
                }
            });
        },
        created () {
            if (this.$route.query.isProvPriv == 1) {
                this.isProvPriv = this.$route.query.isProvPriv
                this.year = this.$route.query.year
                this.quarter = this.$route.query.quarter
                this.cityCode = this.$route.query.area
                this.cityName = this.$route.query.areaName
                this.quarterName = this.$route.query.quarterName
                this.complainQuarter = this.$route.query.complainQuarter
                this.compickFlag = this.$route.query.compickFlag
                this.compickFlag2 = this.$route.query.compickFlag2
                this.getAssessScore()
                this.getCity()
            } else {
                this.getCity()
            }
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;

    .back-contain{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0,0,0,0.3);
      z-index: 999;
      .tap-box{
        margin: 260px 58px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        background:rgba(255,255,255,1);
        border-radius:3px;
        .content{
          margin-top: 33px;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:14px;
          .con{
            margin-bottom: 10px;
          }
        }
        .iknow{
          margin-top: 14px;
          width:228px;
          height:38px;
          background:rgba(54,179,116,1);
          border-radius:2px;
          border:1px solid rgba(54,179,116,1);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size:14px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(255,255,255,1);
          line-height:14px;
          margin-bottom: 16px;
        }
      }
    }

  .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 24px;
    }
    .noData-bg{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 100px;
    }
    .prov-total{
      .prov-title{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:bold;
        color:rgba(51,51,51,1);
        margin-top: 24px;
      }
      &-sel{
        display: flex;
        justify-content: space-between;
        .select{
          display: flex;
          align-items: center;
          line-height:14px;
          span{
            font-size:14px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:bold;
            color:rgba(74,74,74,1);
            padding-right: 4px;
          }
          .select-icon{
            width:6px;
            height: 4px;
            background: url('../../assets/image/xiala.png') no-repeat;
            background-size: 6px 4px;
          }
        }
        .search{
          width: 15px;
          height: 15px;
          background: url('../../assets/image/sousuo.png') no-repeat;
          background-size: 15px 15px;
        }
      }
      .mt20{
        margin-top: 20px!important;
      }
      .content{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-top: 12px;
        &-item{
          display: flex;
          justify-content: center;
          .total{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .total:nth-child(2){
            border-left: solid 1px #EEEEEE;
          }
        }
        &-item:first-child{
          border-bottom: solid 1px #EEEEEE;
        }
        &-item:last-child{
          border-bottom: 0;
        }
        &-pd16{
          padding-top: 16px;
          .mt0{
            margin-top: 0;
          }
          .mt13{
            margin-top: 13px;
          }
          .com-box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            &-left{
              display: flex;
              align-items: center;
              font-size:14px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(51,51,51,1);
              line-height:20px;
            }
            .van-switch{
              border: solid 1Px #E4E4E5;
              width: 40px;
              height: 24px;
            }
            .van-switch.van-switch--on{
              border: solid 1Px #36B374;
            }
            .van-switch__node{
              box-shadow:none;
              width: 22px;
              height: 22px;
              top: 1px;
              left: 1px;
            }
            .van-switch--on .van-switch__node{
              left: 0;
            }
            &-right{
              display: flex;
              justify-content: flex-end;
              align-items: center;
              font-size:12px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(102,102,102,1);
              line-height:12px;
              .icon{
                width: 12px;
                height: 12px;
                margin-left: 4px;
              }
            }
          }
        }

          .time-cont{
            .score-num{
              font-size:14px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(51,51,51,1);
              line-height:20px;
              padding: 16px 16px 0 16px;
            }
            .score-list{
              margin-top: 8px;
              .score-item{
                padding: 16px;
                border-bottom: solid 1px #EEEEEE;
                .tit{
                  display: flex;
                  justify-content: space-between;
                    font-size:14px;
                    font-family:PingFangSC-Medium,PingFang SC;
                    font-weight:500;
                    line-height:14px;
                  .name{
                    color:rgba(51,51,51,1);
                  }
                  .down{
                    color: #FF4D4D;
                  }
                }
                .txt{
                  font-size:12px;
                  font-family:PingFangSC-Regular,PingFang SC;
                  font-weight:400;
                  color:rgba(102,102,102,1);
                  line-height:12px;
                  margin-top: 12px;
                }
              }
              .score-item:last-child{
                border-bottom: none;
              }
            }
          }
      }
    }
  }
  /deep/.van-switch__node{
        top: 4px!important;
  }
</style>
